import React, { Fragment, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";


import Axios from "axios";
import { BASE_URL } from "../../redux/constants";
import Auth from "../../config/auth";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import storeId from "../../config/storeId";
import { Spinner } from "reactstrap";

const Layout = (props) => {

  const history = useHistory()
  const storeName = storeId();
  // Remove saved data from sessionStorage
  // sessionStorage.removeItem("order_id");
  //let order_id = sessionStorage.getItem("order_id");

  async function viewStore() {
    const token = Auth.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await Axios.get(
        `${BASE_URL}/products/view/all/${storeName}`,
        token != null && ({
          headers
        })
      );
      if (response.data.hasError) {
        console.log(response.data);
      } else {
        //setStore(response.data.data.store);
        const {store} = response.data.data
        if(!store.published){
          history.push('/')
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(()=>{
    viewStore();
  },[])


  return (
    <Fragment style={{ backgroundColor: "#F6F8FA" }}>
      <Header />
      {props.children}
      <Footer />
    </Fragment>
  );
};
export default Layout;
